import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/display.css'

import 'bootstrap-sass/assets/stylesheets/_bootstrap.scss'
// import './element-variables.scss'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
// import GSignInButton from 'vue-google-signin-button'

/*
// https://github.com/MMF-FE/vue-svgicon
import * as svgicon from 'vue-svgicon'
Vue.use(svgicon, {
  tagName: 'svgicon'
})

import N3Components from 'N3-components'
import 'N3-components/dist/index.min.css'
// install N3
Vue.use(N3Components, 'en')

import KeenUI from 'keen-ui'
Vue.use(KeenUI)
*/
// Vue.use(GSignInButton)
Vue.config.productionTip = false
Vue.config.debug = process.env.DEBUG_MODE

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js